const getShipmentProperties = (shipmentDetails) => [
  { label: "Pros", value: shipmentDetails.totalProps },
  { label: "Priority", value: shipmentDetails.priority },
  { label: "HU", value: shipmentDetails.hu },
  { label: "Special Needs", value: shipmentDetails.specialNeeds },
  { label: "Weight", value: shipmentDetails.totalWeight },
  { label: "PSE", value: shipmentDetails.pse },
  { label: "No. Of Stops", value: shipmentDetails.totalStops },
];

const Default_Shipment_Properties = {
  shipments: [],
  pros: 0,
  hu: 0,
  priority: 0,
  specialNeeds: 0,
  weight: 0,
  pse: 0,
  totalStops: 0,
};

const getLassoBadgeLabel = (shipment) => {
  return shipment.isDelivery ? shipment.consigneeName : shipment.shipperName;
};

export {
  Default_Shipment_Properties,
  getShipmentProperties,
  getLassoBadgeLabel,
};
